/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateResellerApiAccount201Response
 */
export interface CreateResellerApiAccount201Response {
    /**
     * 
     */
    accountId: string;
    /**
     * OAuth client_id for the client credentials grant.
     */
    clientId: string;
    /**
     * Client secret - returned only once. Store it securely.
     */
    clientSecret: string;
    /**
     * Keycloak token endpoint to request access tokens from (grant_type=client_credentials).
     */
    tokenEndpoint: string;
}

/**
 * Check if a given object implements the CreateResellerApiAccount201Response interface.
 */
export function instanceOfCreateResellerApiAccount201Response(value: object): value is CreateResellerApiAccount201Response {
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('clientSecret' in value) || value['clientSecret'] === undefined) return false;
    if (!('tokenEndpoint' in value) || value['tokenEndpoint'] === undefined) return false;
    return true;
}

export function CreateResellerApiAccount201ResponseFromJSON(json: any): CreateResellerApiAccount201Response {
    return CreateResellerApiAccount201ResponseFromJSONTyped(json, false);
}

export function CreateResellerApiAccount201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateResellerApiAccount201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'accountId': json['accountId'],
        'clientId': json['clientId'],
        'clientSecret': json['clientSecret'],
        'tokenEndpoint': json['tokenEndpoint'],
    };
}

export function CreateResellerApiAccount201ResponseToJSON(json: any): CreateResellerApiAccount201Response {
    return CreateResellerApiAccount201ResponseToJSONTyped(json, false);
}

export function CreateResellerApiAccount201ResponseToJSONTyped(value?: CreateResellerApiAccount201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accountId': value['accountId'],
        'clientId': value['clientId'],
        'clientSecret': value['clientSecret'],
        'tokenEndpoint': value['tokenEndpoint'],
    };
}

